export { viewLog, viewLogSync } from './viewLog';
